import { useCallback, useMemo } from 'react';
import { sprintf } from 'sprintf-js';
import styled from 'styled-components';

import { Link } from 'components/Link';
import { Text } from 'components/Text/Text';
import { colors } from 'theme';
import { LANGUAGES } from 'utils/constants';
import { createCookie } from 'utils/cookies';

const DisabledLink = styled(Text)`
  color: ${colors.lightContentGrey};
  opacity: 0.5;
  cursor: auto;
`;

type Props = {
  locale: UserLocale;
  localeUrl: string | undefined;
};

export function LanguageLinksItem({ locale, localeUrl }: Props) {
  const select = useCallback(
    () => createCookie('_LOCALE_', locale, 1825),
    [locale],
  );

  const title = useMemo(() => {
    if (!localeUrl)
      return sprintf(
        getText('This page is currently not available in %(language)s'),
        { language: LANGUAGES[locale] },
      );

    return '';
  }, [localeUrl, locale]);

  const isSelected = locale !== CURRENT_LOCALE;

  if (isSelected && localeUrl) {
    return (
      <Link
        key={locale}
        href={localeUrl || ''}
        data-qa-id={`locale-link-${locale}`}
        onClick={select}
      >
        {LANGUAGES[locale]}
      </Link>
    );
  }

  return (
    <DisabledLink
      data-qa-id={`disabled-locale-link-${locale}`}
      key={locale}
      title={title}
    >
      {LANGUAGES[locale]}
    </DisabledLink>
  );
}
